import CardLayout from './FeedCardLayout';
import container from './FeedCardLayout.container';
export default container(CardLayout);
